import React, {useState, useContext, useMemo, useEffect} from 'react'
import {Button, IconButton, Divider, Typography, Grid} from '@material-ui/core'
import StepSelectItem from './StepSelectItem'
import StepSelectDate from './StepSelectDate'
import StepDots from '../StepDots'
import CloseIcon from '@material-ui/icons/Close'
import StepSelectAdditionalFields from '../ReservationSteps/StepSelectAdditionalFields'
import StepConfirmReservation from '../ReservationSteps/StepConfirmReservation'
import {ReservationContext} from '../../../context/Reservation/Reservation'
import moment from 'moment'
import _ from 'lodash'
import {UserContext} from '../../../context/User'
import {transformDateFormat, transformTimeFormat} from '../../../context/Reservation/util'

const DateFirst = ({fromGantt, handleReserve, onClose}) => {
  const [step, setStep] = useState(1)
  const [maxStep, setMaxStep] = useState(2)
  const [isMainApp, setIsMainApp] = useState(false)
  const currentUser = useContext(UserContext)
  const date_format = transformDateFormat(currentUser?.details?.account_date_format)
  const time_format = transformTimeFormat(currentUser?.details?.account_time_format)
  const {
    reservation,
    configuration,
    checkObjects,
    update,
    clearReservationsData,
    entityObjects,
  } = useContext(ReservationContext)
  const [groupObjectIds, setGroupObjectIds] = useState([])

  const handleClickNext = () => {
    setStep(prev => {
      if (prev === 2) {
        if (
          configuration.data?.additional_fields &&
          configuration.data.additional_fields.length > 0
        ) {
          return 3
        } else {
          return 4
        }
      }
      return prev + 1
    })
  }

  const handleClickPrev = () => {
    if (step === 3 && fromGantt) {
      setStep(prev => prev - 1)
      update('fromGantt', false)
    } else setStep(prev => prev - 1)
  }

  useEffect(() => {
    if (!fromGantt) {
      if (reservation.selected_items.length && reservation.reserved_for.id && fromGantt) {
        if (
          configuration.data?.additional_fields &&
          configuration.data.additional_fields.length > 0
        ) {
          setStep(3)
        } else {
          setStep(4)
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromGantt, configuration, reservation.selected_items.length, reservation.reserved_for.id])

  useEffect(() => {
    var regex = /pop_reserve/
    setIsMainApp(regex.test(window.location.href))
  }, [])

  const checkSelectedItems = useMemo(() => {
    let op = false
    reservation.selected_items.map(i => {
      checkObjects.data.entity_objects &&
        checkObjects.data.entity_objects.map(c => {
          if (c.id === i.id && c.label === 'disabled') {
            op = true
          }
          return true
        })
      return true
    })
    return op
  }, [checkObjects, reservation])

  useEffect(() => {
    if (configuration.data?.additional_fields && configuration.data.additional_fields.length > 0) {
      setMaxStep(3)
    } else {
      setMaxStep(2)
    }
  }, [configuration])

  const handleEdit = step => {
    setStep(step)
    update('fromGantt', false)
    clearReservationsData()
  }
  const enableNext = useMemo(() => {
    switch (step) {
      case 1:
        return (
          !!reservation.date_from &&
          !!reservation.date_to &&
          moment(reservation.date_from).unix() < moment(reservation.date_to).unix()
        )
      case 2:
        // configuration is loaded and has selected items available
        return (
          !_.isEmpty(configuration.data) &&
          !_.isEmpty(entityObjects.data.entity_objects) &&
          reservation.selected_items.length > 0 &&
          !_.isEmpty(reservation.reserved_for) &&
          !checkSelectedItems
        )
      case 3:
        let output = true
        // configuration is loaded and has selected items
        reservation?.additional_fields
          ? reservation.additional_fields.forEach(i => {
              if (
                (i.is_required === true || configuration.isLoading) &&
                (i.value === undefined || i.value === '')
              ) {
                output = false
              }
            })
          : (output = false)
        return output
      default:
        return false
    }
  }, [reservation, step, configuration, checkSelectedItems, entityObjects])
  return (
    <>
      <div
        className={`c-res-mod ap-modal ${isMainApp && 'mt-0'}`}
        style={
          isMainApp
            ? {width: '95%', height: 'auto'}
            : step <= 3
            ? {width: 960, height: 'auto'}
            : step === 4
            ? {height: 610, width: 440, padding: '21px 0px 16px 32px'}
            : {width: 277, height: 156, padding: 5}
        }
      >
        {!isMainApp && (
          <IconButton className="ap-icon-button ap-modal__btn-x" onClick={onClose}>
            <CloseIcon style={{color: '#1d2331'}} />
          </IconButton>
        )}

        {step <= 4 && (
          <div className="ap-modal__header" style={{marginBottom: 16}}>
            <div className="ap-modal__title">New Reservation</div>
          </div>
        )}
        <div className="ap-modal__body">
          {step === 1 && <StepSelectDate date_format={date_format} time_format={time_format} />}
          {step === 2 && (
            <StepSelectItem date_format={date_format} time_format={time_format} showDate={true} />
          )}
          {step === 3 && <StepSelectAdditionalFields />}
          {step === 4 && (
            <StepConfirmReservation
              handleReserve={handleReserve}
              onClose={onClose}
              handleEdit={handleEdit}
              date_format={date_format}
              time_format={time_format}
            />
          )}
        </div>
        <div style={{display: 'flex', flexDirection: 'row', paddingTop: 16}}>
          <div className="ap-flex ap-flex--start">
            {step > 1 && step <= maxStep && (
              <Button className="ap-button" onClick={handleClickPrev}>
                Back
              </Button>
            )}
          </div>
          <div className="ap-flex ap-flex--center">
            <StepDots step={step} stepCount={maxStep} />
          </div>
          <div className="ap-flex ap-flex--end">
            {step < maxStep && (
              <Button
                className="ap-button ap-button--primary"
                onClick={handleClickNext}
                disabled={!enableNext}
              >
                Next
              </Button>
            )}
            {step === maxStep && (
              <Button
                className={`ap-button ap-button--primary `}
                onClick={handleClickNext}
                disabled={!enableNext}
              >
                Next
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default DateFirst
